import { IconProps } from './IconProps';

export const AddIcon = ({ className, width = 20, height = 20 }: IconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <g>
          <g transform="translate(-29.000000, -391.000000) translate(20.408426, 378.000000) translate(9.591574, 14.000000)">
            <path
              fill="#868787"
              fillRule="nonzero"
              d="M14.918 5.09L13.046 3.217 9.068 7.196 5.09 3.217 3.217 5.09 7.196 9.068 3.217 13.046 5.09 14.918 9.068 10.94 13.046 14.918 14.918 13.046 10.94 9.068z"
              transform="translate(9.067500, 9.067500) rotate(45.000000) translate(-9.067500, -9.067500)"
            />
            <circle cx="9.068" cy="9.068" r="9.068" stroke="#868787" strokeWidth="1.17" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
